import React, { useEffect, useState } from "react";
import "./myorders.css";
import { useNavigate } from "react-router-dom";

const OrderCard = () => {
  const [orders, setOrders] = useState([]);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  // Fetch orders
  useEffect(() => {
    if (!config) return;

    const fetchOrders = async () => {
      try {
        const response = await fetch(
          `${config.BASE_URL}${config.GET_ORDERED_PRODUCTS}`,
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
          }
        );

        const data = await response.json();
        if (data.status) {
          setOrders(data.orders || []);
        } else {
          console.error("Failed to fetch orders:", data.message);
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [config]);

  // Fetch status for each order
const fetchOrderStatus = async (user_id, product_id) => {
  try {
    const response = await fetch(
      `${config.BASE_URL}${config.GET_ORDER_STATUS}`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product_id }), 
      }
    );
    const data = await response.json();
   // console.log("Order status response:", data);
    return data.message || "Pending";
  } catch (err) {
    console.error("Error fetching order status:", err);
    return "Pending";
  }
};


  // Handle view details
  const handleViewDetails = async (product_id) => {
    try {
      const response = await fetch(
        `${config.BASE_URL}${config.GET_PRODUCTS}`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (data.success && data.products) {
        const product = data.products.find(
          (p) => p.product_id === product_id
        );

        if (product) {
          navigate("/product-details", { state: { product } });
        } else {
          console.error("Product not found:", product_id);
        }
      } else {
        console.error("Failed to fetch products:", data.message);
      }
    } catch (err) {
      console.error("Error fetching product details:", err);
    }
  };

  if (loading) return <p>Loading orders...</p>;
  
  if (!orders.length) 
  return (
    <div className="no-orders">
      <h3>Oops! Looks like your robots haven't delivered anything yet 🤖</h3>
      <p>But don’t worry, you can always add some cool gadgets!</p>
      <button 
        className="continue-shop-button" 
        onClick={() => navigate("/products")}
      >
        Continue Shopping
      </button>
    </div>
  );


  return (
    <div className="order-cards-wrapper">
      <h2 className="orders-title">Your Orders</h2>

      <div className="order-cards-container">
        {orders.map((order) => (
          <OrderItem
            key={order.id}
            order={order}
            fetchOrderStatus={fetchOrderStatus}
            onViewDetails={handleViewDetails}
          />
        ))}
      </div>
    </div>
  );
};

// Sub-component for each order
const OrderItem = ({ order, fetchOrderStatus, onViewDetails }) => {
  const [status, setStatus] = useState("Loading...");

  useEffect(() => {
    const loadStatus = async () => {
      const s = await fetchOrderStatus(order.user_id, order.product_id);
      setStatus(s);
    };
    loadStatus();
  }, [order, fetchOrderStatus]);

  return (
    <div className="order-card">
      <img
        src={
          `/product_thumbnails/${order.product_id}/${order.image_path}` ||
          "/placeholder.png"
        }
        alt={order.title}
        className="order-card-image"
      />
      <p className="order-card-description">{order.title}</p>
      <div className="order-card-footer">
        <span className="order-status">{status}</span>
        <button
          className="view-details-btn"
          onClick={() => onViewDetails(order.product_id)}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default OrderCard;
